import { useQuery, useQueryClient } from '@tanstack/react-query';
import { QUERY_KEY } from 'es/app/business-logic/queryKey';
import { fetchUnknownUserTemplates } from 'es/app/views/system/sso-user-templates/fetchUnknownUserTemplates';
import { useCallback } from 'react';

const ONE_HOUR_MILLIS = 1000 * 60 * 60;

export function useUnknownUserTemplates() {
    const queryClient = useQueryClient();
    const { data, isFetching } = useQuery({
        queryKey: [QUERY_KEY.unknownUserTemplates],
        queryFn: () => fetchUnknownUserTemplates(),
        select: data => data.sort((a, b) => a.domain.localeCompare(b.domain)),
        staleTime: ONE_HOUR_MILLIS,
    });
    return {
        unknownUserTemplates: data,
        isFetchingTemplates: isFetching,
        invalidateTemplates: useCallback(() => {
            queryClient.invalidateQueries({
                queryKey: [QUERY_KEY.unknownUserTemplates],
            });
        }, [queryClient]),
    };
}
